/**
 * Iterate over every simple Geometry in an {@link Iterable} of Geometry, Feature or FeatureCollection objects
 *
 * Simple Geometry objects are Point, MultiPoint, LineString, MultiLineString, Polygon or MultiPolygon, but not GeometryCollection
 *
 * @param objects - the objects to iterate over
 */
export function* iterGeometries(objects) {
    for (const object of objects) {
        switch (object.type) {
            case 'Point':
            case 'MultiPoint':
            case 'LineString':
            case 'MultiLineString':
            case 'Polygon':
            case 'MultiPolygon':
                yield object;
                break;
            case 'GeometryCollection':
                yield* iterGeometries(object.geometries);
                break;
            case 'Feature':
                yield* iterGeometries([object.geometry]);
                break;
            case 'FeatureCollection':
                yield* iterGeometries(object.features);
                break;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXRlckdlb21ldHJpZXMuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsiaXRlckdlb21ldHJpZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0E7Ozs7OztHQU1HO0FBQ0gsTUFBTSxTQUFTLENBQUMsQ0FBQyxjQUFjLENBQzlCLE9BQXlEO0lBRXpELEtBQUssTUFBTSxNQUFNLElBQUksT0FBTyxFQUFFLENBQUM7UUFDOUIsUUFBUSxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDckIsS0FBSyxPQUFPLENBQUM7WUFDYixLQUFLLFlBQVksQ0FBQztZQUNsQixLQUFLLFlBQVksQ0FBQztZQUNsQixLQUFLLGlCQUFpQixDQUFDO1lBQ3ZCLEtBQUssU0FBUyxDQUFDO1lBQ2YsS0FBSyxjQUFjO2dCQUNsQixNQUFNLE1BQU0sQ0FBQTtnQkFDWixNQUFLO1lBRU4sS0FBSyxvQkFBb0I7Z0JBQ3hCLEtBQUssQ0FBQyxDQUFDLGNBQWMsQ0FBQyxNQUFNLENBQUMsVUFBVSxDQUFDLENBQUE7Z0JBQ3hDLE1BQUs7WUFFTixLQUFLLFNBQVM7Z0JBQ2IsS0FBSyxDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUE7Z0JBQ3hDLE1BQUs7WUFFTixLQUFLLG1CQUFtQjtnQkFDdkIsS0FBSyxDQUFDLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxRQUFRLENBQUMsQ0FBQTtnQkFDdEMsTUFBSztRQUNQLENBQUM7SUFDRixDQUFDO0FBQ0YsQ0FBQyJ9